import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { CloseSmallIcon, IconButton, Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";
import { deleteTasksDependency, fetchTaskDependenciesSuggestions } from "~/store/actions/actions.taskDependencies.jsx";
import { hasCollaborativePermissionsOnProject } from "~/store/selectors/selector.users.jsx";

const DeleteTaskDependecy = ({ taskId, id, isParent, projectId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const canEdit = useSelector((state) => hasCollaborativePermissionsOnProject(state, projectId));
  const handleClick = useCallback(() => {
    dispatch(deleteTasksDependency(taskId, id, projectId, isParent)).then(() => {
      dispatch(fetchTaskDependenciesSuggestions(taskId));
    });
  }, [dispatch, id, isParent, taskId, projectId]);

  return canEdit ? (
    <Tooltip title={t("Remove Dependency")}>
      <IconButton
        variant="text gray"
        size="small"
        className="delete_task_dependency"
        onClick={handleClick}
      >
        <CloseSmallIcon />
      </IconButton>
    </Tooltip>
  ) : null;
};

DeleteTaskDependecy.propTypes = {
  taskId: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  isParent: PropTypes.bool,
  onClick: PropTypes.func,
};

DeleteTaskDependecy.defaultProps = {
  isParent: false,
};

export default DeleteTaskDependecy;
